document.addEventListener('DOMContentLoaded', function () {
	const availabilityMap = {
		good: { class: 'good', text: 'Hyvin saatavilla' },
		low: { class: 'low', text: 'Vielä muutama' },
		'out of stock': { class: 'out-of-stock', text: 'Ei saatavilla' }, //Fix for incase class name is invalid
		default: { class: 'not-available', text: 'Ei saatavilla' },
	};
	// Get the current product ID
	const currentProductId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
	const statusLocations = document.querySelectorAll('.single_store');

	statusLocations.forEach((location) => {
		location.addEventListener('click', function () {
			statusLocations.forEach((loc) => loc.classList.remove('highlight'));
			location.classList.add('highlight');
			const storeData = {
				city: location.getAttribute('data-city'),
				name: location.getAttribute('data-name'),
				availability: location.getAttribute('data-availability'),
				productId: currentProductId, // Store product ID along with data
			};

			localStorage.setItem('storeData', JSON.stringify(storeData));
			updateStoreDisplay();
		});
	});

	function updateStoreDisplay() {
		const retrievedStoreData = JSON.parse(localStorage.getItem('storeData'));
		const targetDiv = document.querySelector('#target-item');
		console.log('STORAGE DATA USED:', retrievedStoreData);
		const currentProductId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
		console.log(currentProductId, 'SECOND ID');
		// Get all store names for the new product and their updated availability
		const availableStores = [...document.querySelectorAll('.single_store')].map((store) => ({
			name: store.getAttribute('data-name'),
			availability: store.getAttribute('data-availability'),
		}));
		// If switching products, update availability if store exists; otherwise, reset selection
		if (retrievedStoreData && retrievedStoreData.productId !== currentProductId) {
			const matchingStore = availableStores.find((store) => store.name === retrievedStoreData.name);
			if (matchingStore) {
				console.log('Switching products, updating availability for existing store.');
				retrievedStoreData.availability = matchingStore.availability;
				localStorage.setItem('storeData', JSON.stringify(retrievedStoreData));
			} else {
				localStorage.removeItem('storeData');
				return;
			}
		}

		if (retrievedStoreData && targetDiv) {
			let storeDiv = targetDiv.nextElementSibling;
			if (!storeDiv || !storeDiv.classList.contains('single_store')) {
				storeDiv = document.createElement('div');
				storeDiv.className = 'single_store';
				const { availability } = retrievedStoreData;
				const { class: statusClass, text: statusText } =
					availabilityMap[availability] || availabilityMap.default;

				// Inject store availability display
				storeDiv.innerHTML = `
                    <div class="store-availability-container">
                        <p id="status-location-text" class="status-location"></p>
                        <div class="dots-container" style="display:flex; align-items:center;">
                            <span class="status-dot ${statusClass}"></span>
                            <p is="toggle-button" aria-controls="{{ drawer_id }}" aria-expanded="false" id="status-location-status">
                                ${statusText}
                            </p>
                        </div>
                    </div>
                `;
				targetDiv.insertAdjacentElement('afterend', storeDiv);
			}

			storeDiv.querySelector('.status-location').textContent = `${retrievedStoreData.city}: ${retrievedStoreData.name}`;
			const statusDot = storeDiv.querySelector('.status-dot');
			statusDot.classList.forEach((className) => {
				if (className !== 'status-dot') {
					statusDot.classList.remove(className);
				}
			});

			//Get correct availability class and replace spaces with hyphens
			let safeClassName = retrievedStoreData.availability.replace(/\s+/g, '-');
			statusDot.classList.add(safeClassName);
			const statusText = storeDiv.querySelector('#status-location-status');
			const availabilityData =
				availabilityMap[retrievedStoreData.availability] || availabilityMap.default;
			statusText.textContent = availabilityData.text;
		}
	}
	updateStoreDisplay();
	window.addEventListener('storage', function (event) {
		if (event.key === 'storeData') {
			updateStoreDisplay();
		}
	});
});
